import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const PaintingDecoration = () => {
  // State management
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Data structure
  const painting_decoration = {
    name: "Painting & Decoration",
    subcategories: {
      paint_treatments: {
        name: "Paint & Wood Treatments",
        options: {
          paints: {
            name: "Paints",
            options: {
              general_paint: {
                name: "General Purpose Paint",
                products: [
                  {
                    name: "All-Surface Paint",
                    image: "/assets/productimages/paint.webp",
                    use: "Surface coating",
                    details: "Water-based, 5L tin, various colors",
                    price: ""
                  }
                ]
              },
              masonry: {
                name: "Masonry Paint",
                products: [
                  {
                    name: "Exterior Masonry Paint",
                    image: "/assets/productimages/masonarypaint.jpg",
                    use: "Exterior wall coating",
                    details: "Weather-resistant, 10L tub",
                    price: ""
                  }
                ]
              },
              interior: {
                name: "Interior Emulsion",
                products: [
                  {
                    name: "Washable Matt Emulsion",
                    image: "/assets/productimages/interior.jpg",
                    use: "Wall coating",
                    details: "Scrubbable finish, 2.5L tin",
                    price: ""
                  }
                ]
              },
              metal: {
                name: "Metal Paint",
                products: [
                  {
                    name: "Rust-Inhibiting Metal Paint",
                    image: "/assets/productimages/metalpaint.jpg",
                    use: "Metal surface coating",
                    details: "Direct-to-rust formula, 1L tin",
                    price: ""
                  }
                ]
              }
            }
          },
          preparations: {
            name: "Paint Preparations",
            options: {
              primers: {
                name: "Primers & Undercoats",
                products: [
                  {
                    name: "Multi-Surface Primer",
                    image: "/assets/productimages/primerundercoats.jpeg",
                    use: "Surface preparation",
                    details: "High-adhesion primer, 1L tin",
                    price: ""
                  }
                ]
              },
              solvents: {
                name: "Solvents & Thinners",
                products: [
                  {
                    name: "Paint Thinner",
                    image: "/assets/productimages/thinners.jpeg",
                    use: "Paint preparation",
                    details: "1L bottle, universal thinner",
                    price: ""
                  }
                ]
              }
            }
          }
        }
      },
      decorating_tools: {
        name: "Decorating Tools & Supplies",
        options: {
          application_tools: {
            name: "Application Tools",
            options: {
              brushes: {
                name: "Paint Brushes",
                products: [
                  {
                    name: "Professional Paint Brush Set",
                    image: "/assets/productimages/paintbrush.jpeg",
                    use: "Application tools",
                    details: "3-piece synthetic bristle set",
                    price: ""
                  }
                ]
              },
              rollers: {
                name: "Paint Rollers",
                products: [
                  {
                    name: "Medium Pile Roller Kit",
                    image: "/assets/productimages/paintroller.jpeg",
                    use: "Application tools",
                    details: "9 roller with frame and tray",
                    price: ""
                  }
                ]
              }
            }
          },
          masking_supplies: {
            name: "Masking Supplies",
            products: [
              {
                name: "Painter's Masking Tape",
                image: "/assets/productimages/tape.jpeg",
                use: "Masking materials",
                details: "50mm x 50m low-tack tape",
                price: ""
              }
            ]
          }
        }
      },
      //  air_circulation: {
      //     name: "Air Circulation",
      //     options: {
      //       fans: {
      //         name: "Fans and Extractors",
      //         images: ["/assets/productimages/fans.jpg"],
      //         products: [
      //           {
      //             name: "Industrial Extractor Fan",
      //             image: "/assets/exhaustfans/fan1.png",
      //             use: "Air circulation systems",
      //             details: "High-capacity ventilation fan",
      //             price: "$149.99"
      //           },
      //           {
      //             name: "Axial fan REST D100 mesh back valve ERA",
      //             image: "/assets/exhaustfans/fan2.png",
      //             use: "Ventilation systems",
      //             details: "High-efficiency axial fan with back-draught valve",
      //             price: "$129.99"
      //           },
      //           {
      //             name: "Axial fan WIND D100 back-draught valve",
      //             image: "/assets/exhaustfans/fan3.png",
      //             use: "Ventilation systems",
      //             details: "Compact axial fan with back-draught valve for improved airflow",
      //             price: "$139.99"
      //           },
      //           {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan4.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           },
      //           {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan5.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan6.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           },
      //           {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan7.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan8.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan9.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           },

      //           {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan10.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan11.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan12.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           },
      //           {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan13.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           }, {
      //             name: "Axial fan WIND D120 back-draught valve",
      //             image: "/assets/exhaustfans/fan14.png",
      //             use: "Ventilation systems",
      //             details: "Larger axial fan with D120 back-draught valve for high efficiency",
      //             price: "$159.99"
      //           },
      //         ]
      //       }
      //     }
      //   },
    }
  };

  // Handlers
  const handleSubcategoryClick = (subcategoryKey) => {
    setActiveSubcategory(subcategoryKey);
    setActiveOption(null);
  };

  const handleOptionClick = (optionKey) => {
    setActiveOption(optionKey);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  // Render subcategories
  const renderSubcategories = () => {
    if (!painting_decoration?.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(painting_decoration.subcategories).map(
            ([key, subcategory]) => (
              <button
                key={key}
                className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                onClick={() => handleSubcategoryClick(key)}
              >
                {subcategory?.name ?? "Unnamed Subcategory"}
              </button>
            )
          )}
        </div>
      </div>
    );
  };

  // Render options
  const renderOptions = () => {
    if (!activeSubcategory) return null;

    const subcategory =
      painting_decoration?.subcategories?.[activeSubcategory];
    if (!subcategory?.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(subcategory.options).map(([key, option]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              onClick={() => handleOptionClick(key)}
            >
              {option?.name ?? "Unnamed Option"}
            </button>
          ))}
        </div>
      </div>
    );
  };

  // Render products
  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption) {
      const option =
        painting_decoration?.subcategories?.[activeSubcategory]?.options?.[
        activeOption
        ];
      if (option?.products) {
        products = option.products;
      } else if (option?.options) {
        const nestedOptionKey = Object.keys(option.options)[0];
        products = option?.options?.[nestedOptionKey]?.products ?? [];
      }
    } else if (
      activeSubcategory &&
      painting_decoration?.subcategories?.[activeSubcategory]?.products
    ) {
      products =
        painting_decoration?.subcategories?.[activeSubcategory]?.products ?? [];
    }

    if (!products || products.length === 0) {
      return (
        <div className="text-center py-10">
          <p className="text-gray-500">
            Select a subcategory and option to view products
          </p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product, index) => (
          <div
            key={index}
            className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleProductClick(product)}
          >
            <div className="h-48 bg-gray-200 overflow-hidden">
              <img
                src={product?.image ?? "/placeholder.png"}
                alt={product?.name ?? "Unnamed Product"}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">
                {product?.name ?? "Unnamed Product"}
              </h3>
              <p className="text-gray-600 mb-2">
                {product?.use ?? "No use info"}
              </p>
              {/* <p className="text-blue-600 font-bold">
                {product?.price || "Price not available"}
              </p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Modal
  const renderProductModal = () => {
    if (!isModalOpen || !selectedProduct) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">
                {selectedProduct?.name ?? "Unnamed Product"}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✖
              </button>
            </div>

            <div className="mb-4">
              <img
                src={selectedProduct?.image ?? "/placeholder.png"}
                alt={selectedProduct?.name ?? "Unnamed Product"}
                className="w-full h-64 object-cover rounded"
              />
            </div>

            <div className="space-y-3">
              <div>
                <h3 className="font-semibold">Uses:</h3>
                <p>{selectedProduct?.use ?? "N/A"}</p>
              </div>

              <div>
                <h3 className="font-semibold">Details:</h3>
                <p>{selectedProduct?.details ?? "N/A"}</p>
              </div>
{/* 
              <div>

                <p className="text-blue-600 font-bold">
                  {selectedProduct?.price || "Price not available"}
                </p>
              </div> */}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 py-2">
        <h1 className="text-3xl font-bold mb-3">
          {painting_decoration.name} Products
        </h1>

        {renderSubcategories()}
        {renderOptions()}
        {renderProducts()}
        {renderProductModal()}
      </div>
    </>
  );
};

export default PaintingDecoration;
